export var valuesPowerBiObjectPermissionLevelEnum = ["Global", "Market", "Country", "Retailer", "None"];
/*

*/ 
//# sourceMappingURL=PowerBiObjectPermissionLevelEnum.js.map